import { Button } from '@/components/ui/button'

interface Props {
  contract: any
}

export const WebEula = ({ contract }: Props): JSX.Element => {
  return (
    <div className="grow px-5 pt-[40px] sm:pt-[70px]">
      <div className="mx-auto w-full max-w-[940px] rounded-lg bg-white p-[35px_16px_30px] sm:p-[50px_44px]">
        <div
          tabIndex={0}
          className="mx-auto flex w-full flex-col gap-5 lg:max-w-[640px]"
        >
          <div key={contract.id}>
            <h2 className="mb-5 text-center text-lg font-bold text-[#222222] sm:mb-[38px] sm:text-2xl">
              {contract.title}
            </h2>
            <div className="policy-section">
              <div
                className="text-justify text-[15px] leading-normal text-[#666666] sm:text-[13px]"
                dangerouslySetInnerHTML={{
                  __html: contract.content,
                }}
              />
            </div>
          </div>
        </div>

        <Button
          variant="light"
          onClick={() => window.close()}
          className="mx-auto mt-[30px] flex w-[270px]"
        >
          閉じる
        </Button>
      </div>
    </div>
  )
}
